import { View } from './view'

export const Loading = View
